import {
  accountApi,
  addressVerifyApi,
  applicationApi,
  benefitsApi,
  connectionFeedbackApi,
  connectionRequestsApi,
  copilotApi,
  emailVerifyApi,
  expertApi,
  invitationApi,
  levelsApi,
  phoneVerifyApi,
  supportFormApi,
  userApi,
  verificationsApi,
} from './endpoints';

export const {
  useUpdateAccountMutation,
  useInvitationMutation,
  useDestroyTeamMemberMutation,
  useDestroyInvitationMutation,
  useDestroyAccountMutation,
  useStorageSASMutation,
  useTransferAdminMutation,
} = accountApi;
export const { useAddressVerifyMutation } = addressVerifyApi;
export const {
  useCreateApplicationMutation,
  useDestroyApplicationMutation,
  useValidateApplicationAddressMutation,
  useValidateApplicationAffiliationsMutation,
  useValidateApplicationIntroductionMutation,
  useValidateApplicationStartupDetailsMutation,
} = applicationApi;
export const {
  useActivateUrlBenefitMutation,
  useActivateAzureBenefitMutation,
  useActivateATABenefitMutation,
  useActivateVisualStudioBenefitMutation,
  useDestroyVisualStudioBenefitMutation,
} = benefitsApi;
export const { useEmailVerifyMutation, useEmailTokenValidationMutation } = emailVerifyApi;
export const { usePhoneVerifyMutation, usePhoneTokenValidationMutation } = phoneVerifyApi;
export const { useUpgradeLevelMutation } = levelsApi;
export const { useUpdateUserMutation, useLogoutMutation, useAcceptAgreementMutation, useDeleteUserMutation } = userApi;
export const { useAcceptInvitationMutation, useResendInvitationMutation } = invitationApi;
export const { useRequestBvMutation, useBvAppealMutation, useRequestDvMutation, useDvAppealMutation } =
  verificationsApi;
export const { useUpdateExpertDetailMutation } = expertApi;
export const { useCreateConnectionRequestMutation, useUpdateConnectionRequestMutation } = connectionRequestsApi;
export const { useCreateFeedbackMutation } = connectionFeedbackApi;
export const { useCreateChatMutation, useUpdateChatMutation, useUpdateMessageFeedbackMutation } = copilotApi;
export const { useCreateUserSupportCaseMutation, useCreateAnonSupportCaseMutation } = supportFormApi;
